import axios from "axios";

import { IGetPendingBookingTotalParams, ITotalMobilityStoreActivitiesByRegion } from "../../pages/dashboard/types";

export const getTotalMobilityStoresActivitiesByRegion = async (params: IGetPendingBookingTotalParams): Promise<ITotalMobilityStoreActivitiesByRegion> => {
    const response = await axios.post('/booking/dashboard/total/byRegions', params);
    return response.data;
};
